(() => {
  const desktop = window.matchMedia('(min-width: 990px)');

  const bindHoverMenus = (root = document) => {
    root.querySelectorAll('.clarhok-visual-menu').forEach((menu) => {
      if (menu.dataset.clarhokHoverBound === 'true') return;
      menu.dataset.clarhokHoverBound = 'true';
      const summary = menu.querySelector(':scope > summary');
      let closeTimer;

      const openMenu = () => {
        if (!desktop.matches) return;
        window.clearTimeout(closeTimer);
        menu.open = true;
        summary?.setAttribute('aria-expanded', 'true');
      };

      const closeMenu = () => {
        if (!desktop.matches) return;
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          menu.open = false;
          summary?.setAttribute('aria-expanded', 'false');
        }, 140);
      };

      menu.addEventListener('pointerenter', openMenu);
      menu.addEventListener('pointerleave', closeMenu);
      menu.addEventListener('focusin', openMenu);
      menu.addEventListener('focusout', (event) => {
        if (!menu.contains(event.relatedTarget)) closeMenu();
      });
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          menu.open = false;
          summary?.setAttribute('aria-expanded', 'false');
          summary?.focus();
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindHoverMenus());
  } else {
    bindHoverMenus();
  }
  document.addEventListener('shopify:section:load', (event) => bindHoverMenus(event.target));
})();
